import { Layout } from "antd";
import { ViewerRegistrationForm } from "features/viewer-registration";
import { AuthHeader } from "widgets/headers";

export const RegistrationPage = () => {
  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "10vh",
        }}
        className="auth-layout-content"
      >
        <ViewerRegistrationForm />
      </Layout.Content>
    </Layout>
  );
};
